import React from 'react';

import { createIcon } from '../createIcon';

function SvgArrowBack(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M2 2h12v12H2z" />
        <path
          d="M5.83 6.808h6.96c.52 0 .949.27 1.13.744a1.175 1.175 0 01-1.085 1.6H5.853l.09.09 2.689 2.75c.452.473.474 1.15.068 1.623-.43.473-1.153.518-1.605.09-.406-.406-.79-.811-1.197-1.217-1.175-1.217-2.35-2.412-3.525-3.629-.497-.518-.497-1.217 0-1.735C3.909 5.546 5.468 3.969 7.005 2.39c.203-.203.43-.338.723-.383.588-.068 1.152.315 1.265.901.068.428-.045.79-.338 1.082l-2.69 2.75c-.067 0-.09.022-.135.067z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export const ArrowBackFilledIcon = createIcon(SvgArrowBack, 'ArrowBackFilledIcon');
